import React from 'react';

export const MinesCoverArtwork = ({ id }) => <>
  <defs>
    <radialGradient id={`${id}-bomb-surface`} cx=".28" cy=".22" r=".9" gradientUnits="objectBoundingBox"><stop stopColor="#6a94a8" /><stop offset=".46" stopColor="#294659" /><stop offset="1" stopColor="#102333" /></radialGradient>
    <linearGradient id={`${id}-emerald-surface`} x1="0" y1="0" x2="142" y2="145" gradientUnits="userSpaceOnUse"><stop stopColor="#91ffd4" /><stop offset=".45" stopColor="#28eaa2" /><stop offset="1" stopColor="#04a36c" /></linearGradient>
  </defs>
  <path d="M0 111h300M0 214h300M0 317h300M74 0v400M184 0v400M294 0v400" stroke="#a8ffdf" strokeOpacity=".1" strokeWidth="3" />
  <ellipse cx="189" cy="269" rx="67" ry="11" fill="#003a4560" />
  <g transform="translate(117 115) rotate(8 67 72)" data-testid={`mines-cover-gem-${id}`}>
    <path d="M29 0H111L141 35L72 140Q70 143 68 140L0 35Z" fill={`url(#${id}-emerald-surface)`} />
    <path d="M0 35L40 39L70 141Z" fill="#0c9a6d" /><path d="M141 35L101 39L70 141Z" fill="#18c88b" />
    <path d="M29 0L40 39L70 0L101 39L111 0Z" fill="#a8ffe1" /><path d="M40 39H101L70 141Z" fill="#60ffc2" />
    <path d="M70 0L101 39H40Z" fill="#e4fff4" /><path d="M29 2L4 34L40 39" stroke="#c0ffe7" strokeOpacity=".8" strokeWidth="2" strokeLinejoin="round" />
    <path d="M40 39H101" stroke="#f0fff9" strokeOpacity=".7" strokeWidth="2" strokeLinecap="round" />
  </g>
  <ellipse cx="75" cy="253" rx="39" ry="8" fill="#04293677" />
  <g transform="translate(73 203) rotate(-17)" data-testid={`mines-cover-bomb-${id}`}>
    <path d="M2-39C2-58 27-46 28-67C29-79 17-81 19-91" stroke="#ffd69f" strokeWidth="6" strokeLinecap="round" />
    <path d="M2-40C3-57 25-47 26-68" stroke="#fff2d3" strokeWidth="2" strokeLinecap="round" />
    <rect x="-12" y="-46" width="26" height="20" rx="5" fill="#243e51" stroke="#7193a2" strokeWidth="2" />
    <circle r="39" fill={`url(#${id}-bomb-surface)`} />
    <path d="M-26-7A28 28 0 0 1-3-27" stroke="#a5d7e1" strokeWidth="7" strokeLinecap="round" strokeOpacity=".65" />
    <path d="M15 28A29 29 0 0 0 29 12" stroke="#091d2a" strokeWidth="5" strokeLinecap="round" strokeOpacity=".5" />
    <path d="M19-105L23-95L33-92L23-88L19-79L15-88L5-92L15-95Z" fill="#ffda75" />
    <circle cx="19" cy="-92" r="4" fill="#fff6ce" />
  </g>
</>;